let on = true;

const off = () => {
  on = false;
};

export default function dev(val, fallbackVal) {
  const activation = process.env.NODE_ENV === 'development' && on;

  if (typeof val === 'function') {
    if (activation) {
      return val();
    }

    return;
  }

  if (activation) {
    return val;
  }

  return fallbackVal;
}

dev.off = off;
dev.abort = (...args) => {
  const activation = process.env.NODE_ENV === 'development' && on;
  if (!activation) return;

  dev(...args);
  // eslint-disable-next-line no-throw-literal
  throw 'Abort for early return, please ingore this.';
};
